import { Journey } from '@breath-lab/types';
import { JourneyStep } from '@breath-lab/types';
import { UserJourney } from '@breath-lab/types';

export function journeyProgressPercent(uj: UserJourney): number {
  const { journey, completedSteps } = uj;
  if (journey.steps.length === 0) {
    return 0;
  }
  return completedSteps.length / journey.steps.length;
}

export function journeyCurrentStep(uj: UserJourney): JourneyStep | null {
  const step = uj.journey.steps[uj.currentStepIndex];
  return step ?? null;
}

export function journeyNextIncompleteStep(uj: UserJourney): JourneyStep | null {
  const completedStepIds = new Set(uj.completedSteps.map(s => s.stepId));
  for (const step of uj.journey.steps) {
    if (!completedStepIds.has(step.id)) {
      return step;
    }
  }
  return null;
}

export function isStepCompleted(uj: UserJourney, stepId: string): boolean {
  return uj.completedSteps.some(s => s.stepId === stepId);
}

export function journeyEstimatedTotalMin(journey: Journey): number {
  return journey.steps.reduce((acc, s) => acc + (s.estimatedDurationMin ?? 0), 0);
}

export function forkJourneyTemplate(journey: Journey, userId: string): UserJourney {
  return {
    id: null,
    userId,
    sourceJourneyId: journey.id,
    journey: { ...journey },
    status: 'active',
    completedSteps: [],
    currentStepIndex: 0,
    startedAt: new Date(),
    lastPracticedAt: null,
    completedAt: null,
  };
}

export function createBlankJourney(_userId: string): Journey {
  return {
    id: '',
    position: 0,
    isEnabled: true,
    name: { en: '' },
    description: { en: '' },
    goal: { en: '' },
    difficulty: 'beginner',
    category: 'general',
    totalSteps: 0,
    steps: [],
    activitiesIds: [],
    benefitsIds: [],
    isAiGenerated: false,
    sourceJourneyId: null,
    createdAt: new Date().toISOString(),
  };
}

export function validateJourney(journey: Journey, validBreathworkIds: string[]): string[] {
  const errors: string[] = [];

  if (journey.steps.length === 0) {
    errors.push('Journey must have at least one step');
  }

  const validIds = new Set(validBreathworkIds);
  for (const step of journey.steps) {
    if (!validIds.has(step.techniques[0]?.breathworkId)) {
      errors.push(`Step "${step.title.en}" references an unknown breathwork`);
    }
  }

  return errors;
}
